module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('i', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Foreword"
    }
  }, [_c('i', [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Acknowledgements"
    }
  }, [_c('i', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Introduction"
    }
  }, [_c('i', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Introduction#h1.1"
    }
  }, [_vm._v("The Allied Convoy System")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Introduction#h1.2"
    }
  }, [_vm._v("Balance Sheet of the U-boat War in the Second World War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Introduction#h1.3"
    }
  }, [_vm._v("German U-boats of World War II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Introduction#h1.4"
    }
  }, [_vm._v("The Commander of "), _c('i', [_vm._v("U-604")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Introduction#h1.5"
    }
  }, [_vm._v("The crew of "), _c('i', [_vm._v("U-604")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Building Yard to First Patrol")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First War Patrol")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brest: the New Home for "), _c('i', [_vm._v("U-604")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Second War Patrol")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("U-boat Recreation Centre at Trevarez, Chateauneuf de Fou")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Third War Patrol")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fourth War Patrol")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fifth War Patrol")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sixth War Patrol")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Return Home from the Sixth War Patrol")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Boat "), _c('i', [_vm._v("U-873")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postscript")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Emblems of")]), _vm._v(" U-604")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_List_of_Crewmen",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("List of Crewmen of")]), _vm._v(" U-604")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_References",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("References")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79a86765","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Contents.vue
// module id = 69
// module chunks = 0